import React from 'react';
import { Card } from 'react-bootstrap';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { EmptyStateCardBody } from '../EmptyStateCard';
import { SkillGapRow } from './logic';
import { SkillGapTable } from './SkillGapTable';

type Props = {
  rows: readonly SkillGapRow[];
};

export const SkillGapCard: React.FC<Props> = ({ rows }) => {
  const t = useNamespacedTranslation('skills.targetProfile');

  return (
    <Card>
      <Card.Header className="d-flex align-items-center gap-1">
        <span className="fw-bold">{t('header')}</span>
        <FlairIcon
          icon="information-circle-outline"
          size="sm"
          className="text-muted"
          tooltip={t('description')}
        />
      </Card.Header>
      {rows.length === 0 ? (
        <EmptyStateCardBody
          title={t('empty.title')}
          subtitle={t('empty.subtitle')}
        />
      ) : (
        <Card.Body>
          <SkillGapTable rows={rows} />
        </Card.Body>
      )}
    </Card>
  );
};
